import { render, staticRenderFns } from "./RetoureEditAddressModal.vue?vue&type=template&id=fae7fcd0&scoped=true"
import script from "./RetoureEditAddressModal.vue?vue&type=script&lang=js"
export * from "./RetoureEditAddressModal.vue?vue&type=script&lang=js"
import style0 from "./RetoureEditAddressModal.vue?vue&type=style&index=0&id=fae7fcd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae7fcd0",
  null
  
)

export default component.exports